import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Form, Input, notification} from 'antd';

import {getSupplier, updateSupplier} from './actions';
import {bindActionCreators} from "redux";
import {getDescriptionFromError} from "../utils/errors";
import InputContact from "../common/InputContact";
import {formItemLayout} from "../utils/style";
import {decodeParams} from "../utils/params";

const FormItem = Form.Item;
const TextArea = Input.TextArea;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class UpdateSupplierForm extends Component {
  componentDidMount() {
    this._load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.supplierId !== this.props.match.params.supplierId) {
      this._load();
    }
  }

  _load = () => {
    const {supplierId} = decodeParams(this.props.match.params);
    this.props.getSupplier({supplierId});
  };

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = e => {
    const {supplierId} = decodeParams(this.props.match.params);
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) return;
      this.props.updateSupplier({...values, supplierId})
        .then(this.goBack)
        .catch(err => notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        }));
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, loading, supplier} = this.props;
    const {name, description, address, contact} = supplier;
    const {
      street: addressStreet,
      city: addressCity,
      state: addressState,
      country: addressCountry,
      postalCode: addressPostalCode,
    } = address || {};
    return (
      <Card title="Update Supplier">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Name"
          >
            {getFieldDecorator('name', {
              initialValue: name,
              rules: [{
                required: true,
                message: 'Name is required'
              }]
            })(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Description"
          >
            {getFieldDecorator('description', {initialValue: description})(
              <TextArea />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Street Address"
          >
            {getFieldDecorator('addressStreet', {initialValue: addressStreet})(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="City"
          >
            {getFieldDecorator('addressCity', {initialValue: addressCity})(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="State/Province"
          >
            {getFieldDecorator('addressState', {initialValue: addressState})(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Country"
          >
            {getFieldDecorator('addressCountry', {initialValue: addressCountry})(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Postal Code"
          >
            {getFieldDecorator('addressPostalCode', {initialValue: addressPostalCode})(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Contact"
          >
            {getFieldDecorator('contact', {initialValue: contact || null})(
              <InputContact key={supplier.supplierId}/>
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Update Supplier
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

UpdateSupplierForm.propTypes = {
  form: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  updateSupplier: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  getSupplier: PropTypes.func.isRequired,
  supplier: PropTypes.object.isRequired,
};

const UpdateSupplierPage = Form.create()(UpdateSupplierForm);

const mapStateToProps = state => ({
  loading: state.supplier.gettingSupplier || state.supplier.updatingSupplier,
  supplier: state.supplier.supplier || {},
});

const mapDispatchToProps = dispatch => ({
  updateSupplier: bindActionCreators(updateSupplier, dispatch),
  getSupplier: bindActionCreators(getSupplier, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateSupplierPage);



// WEBPACK FOOTER //
// ./src/Supplier/UpdateSupplierPage.js